import { componentStyle } from '@/styling/util/component-style.ts';

export const inputTextStyle = componentStyle({
    disabledBackground: '{ color.inputTextDisabledBackground }',
});
